<app-modal modalId="escalationModal" (closeModal)="closeModal()">
    <ng-container>
        <h1 class="modal-heading mb-3">Keine Lösung möglich - Weiterleiten</h1>

        <form [formGroup]="escalationMessageForm" class="item-form">
            <mat-form-field appearance="outline" class="w-100">
                <mat-label>Fehlerbeschreibung</mat-label>
                <textarea
                        matInput
                        formControlName="escalationMessage"
                        rows="15"
                ></textarea>
            </mat-form-field>
        </form>
        <div class="actions d-flex align-items-center justify-content-between mx-3">
            <button class="btn btn-link text-black mt-2" (click)="closeModal()">
                Abbrechen
            </button>
            <button
                    *ngFor="let role of escalationService.getAvailableRoles()"
                    class="btn btn-qundis-escalate mt-2"
                    (click)="onSubmit(role)"
            >an
                {{ role }}
                weiterleiten
            </button>
        </div>

    </ng-container>
</app-modal>
